import { MaterialModule } from '../../material.module';
import { DirectivesMdl } from '../directives/directives-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { DataCollectionComponent  } from './data-table.component';

@NgModule({
    imports: [
        CommonModule, MaterialModule
    ],
    declarations: [
        DataCollectionComponent,
    ],
    exports: [
        DataCollectionComponent,
    ]
})
export class DataCollectionModule {

}
